import React from 'react';
import { STATUS_COLORS, PENDING_COLORS, BOOKING_STATUSES } from '../../constants/statuses';

const StatusBadge = ({ status, initiatedBy = 'host' }) => {
  // Use different pending colors based on who initiated
  let backgroundColor = STATUS_COLORS[status] || '#888';

  if (status === BOOKING_STATUSES.PENDING) {
    backgroundColor = initiatedBy === 'wwoofer'
      ? PENDING_COLORS.WWOOFER_INITIATED
      : PENDING_COLORS.HOST_INITIATED;
  }

  return (
    <span
      className='status-badge'
      style={{ background: backgroundColor }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
